/**
 * @file ドロワーメニュー開閉
 *
 */
'use strict';

/**
 * @classname DrawerAccordion
 * @classdesc ドロワーメニュー開閉
 */
export default class DrawerAccordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('DrawerAccordion.constructor');
		this._$e = $e;
		this._$target = $e.closest('.list__item').find('.list--drawer-inner');
		$e.on('click', () => this.onClick());
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof DrawerAccordion
	 * @return {undefined}
	 */
	onClick(){
		console.log('DrawerAccordion.onClick');
		if(this._$e.hasClass('open')){
			this._$e.removeClass('open').addClass('close');
			this._$target.slideUp({
				complete: () => {
					this._$target.removeClass('open');
				}
			});
		} else{
			this._$e.addClass('open').removeClass('close');
			this._$target.slideDown({
				start: () => {
					this._$target.css({
						display: 'flex'
					})
				}
			});
		}
	}

}
